import React from 'react'
import HistogramaBalanzasView from '../../components/histogramas/HistogramaBalanzasView'

function HistogramaBalanzas () {
  return (
    <div style={{ margin: '2% 0' }}>
      <HistogramaBalanzasView />
    </div>
  )
}

export default HistogramaBalanzas
